import React from 'react';
import { Modal } from '@shopify/polaris';
import { withI18n } from '@shopify/react-i18n';

interface DisableSemanticModalProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  disabling?: boolean;
}

const DisableSemanticModal = (props: DisableSemanticModalProps) => {
  const { open, onClose, onConfirm, disabling, i18n } = props;
  return (
    <Modal
      open={open}
      onClose={onClose}
      title={i18n.translate('AdminHTML.SemanticSearch.Setting.disableTitle')}
      primaryAction={[
        {
          content: i18n.translate('AdminHTML.Common.Action.yes'),
          onAction: onConfirm,
          loading: disabling
        }
      ]}
      secondaryActions={[
        {
          content: i18n.translate('AdminHTML.Common.Action.cancel'),
          onAction: onClose
        }
      ]}>
      <Modal.Section>
        {i18n.translate('AdminHTML.SemanticSearch.Setting.disableContent')}
      </Modal.Section>
    </Modal>
  );
};

export default withI18n()(DisableSemanticModal);